<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Datatable from '@/components/Datatable'
import CreateModal from "./create_modal.vue";
import datatableMixin from '@/helpers/mixins/datatableMixin'


export default {
  mixins: [datatableMixin],
  page: {
    title: "Tarife Yönetimi",
    meta: [
      {
        name: "description",
        content: appConfig.description, 
      },
    ],
  },
  components: {  
    Layout,
    PageHeader,
    Datatable,
    CreateModal
  },
  data() {
    return {
        list: {},
        title: "TARİFE LİSTESİ",
        items: [
          {
            text: "ANASAYFA",
            href: "/",
          },
          {
            text: "TARİFE LİSTESİ",
            active: true,
          },
        ],
        columns: [
          { name: '', key: 'action', orderable: false, width:10  },
          { name: 'Tarife Adı', key: 'name',  orderable: true, width: 350 },
          { name: 'Tarife Tipi', key: 'type', width: 150 },
          { name: 'Hız', key: 'download', className: 'text-end', width: 150  },
          { name: 'Taksit Miktarı', key: 'installment', className: 'text-end', width: 150  },
          { name: 'Durum', key: 'active', className: 'text-end', width: 150  },
          { name: 'Ücreti', key: 'price', className: 'text-end', orderable: true, width: 150  },
        ],
        tableData: {
          detail: false,
          excel: false,
          searchable:{
            visible:true,
            placeholder:"Tarife Adın'da Ara"
          }
        },
        endpoint: '/tariff',
        searchParams: {
          active: 1,
          group_id: '',
          type: '',
        },
        userGroups: [],
    };
  },
  created() {
    this.$http.post('/tariff/user-groups').then(resp => {
      this.userGroups = (resp.data && resp.data.content) ? resp.data.content : (resp.data.data || resp.data);
    });
  },
  methods: {

    async loadPage() {
       
      this.params.page === 1 ?   this.isLoading = true : this.pageLoading = true
          
      const response = await  this.$http.post(this.endpoint, { params: this.params, search_params: this.searchParams, sort:this.sort, search_query: this.searchQuery });
      if (this.params.page === 1) {
          this.tableData.data = response.data.data;
      } else {
          this.tableData.data = [...this.tableData.data, ...response.data.data];
      }
  
      this.tableData.pagination = response.data.meta;
      this.params.page === 1 ?   this.isLoading = false : this.pageLoading = false
    },

     async update(rowData) {
      this.list = rowData
      this.$parent.$bvModal.show('modal-scoped')
    },

    async create() {
      this.list = {}
      this.$parent.$bvModal.show('modal-scoped')
    },

    handleFilterChange() {
      this.params.page = 1
      this.loadPage()
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <CreateModal :list="list" @loadItems="loadPage"  />

    <div class="row">
      <div class="col-12">
        <Datatable 
            :columns="columns" 
            :tableData="tableData" 
            @sort-column="handleSortColumn"
            @search-query="reLoadPage"
            @page-change="pageChange"
            :loading="isLoading"
            :poading="pageLoading">
          
          <!--<template #searchQuery="{ row }">
            <div class="flex-grow-1">
              <input type="text" class="form-control" placeholder="Tarife Adında Ara" @input="search">
            </div>
          </template>-->
         
          <template #toolbar>
            <select class="form-select form-select-sm" style="width:140px" v-model="searchParams.active" @change="handleFilterChange">
              <option :value="1">Aktif</option>
              <option :value="0">Pasif</option>
              <option value="">Tümü</option>
            </select>
            <select class="form-select form-select-sm" style="width:180px" v-model="searchParams.group_id" @change="handleFilterChange">
              <option value="">Tüm Gruplar</option>
              <option v-for="g in userGroups" :key="g.id" :value="g.id">{{ g.name }}</option>
            </select>
            <select class="form-select form-select-sm" style="width:140px" v-model="searchParams.type" @change="handleFilterChange">
              <option value="">Tüm Tipler</option>
              <option value="ADSL">ADSL</option>
              <option value="WIFI">WiFi</option>
              <option value="FIBER">Fiber</option>
            </select>
          </template>

          <template #button>
            <button class="btn btn-sm btn-success" @click="create()">Yeni Oluştur</button>
          </template>

          <template #price="{ row }">
            {{ $paraFormat(row.price) }}
          </template>

           <template #download="{ row }">
            {{ row.upload }}  / {{ row.download }}
          </template>

          <template #installment="{ row }">
            {{ row.installment  ? row.installment + ' Taksit' : ''  }}
          </template>

          <template #active="{ row }">
            <span v-if="row.active"  class="badge rounded-pill bg-success"><i class="fa fa-check"></i> Aktif </span>
            <span v-if="!row.active"  class="badge rounded-pill bg-danger"><i class="fa fa-times"></i> Pasif </span>
          </template> 

          <template #action="{ row }">
            <b-dropdown
                toggle-class="font-size-16 p-0"
                toggle-tag="a"
                variant="white"
                append-to-body
                >
                <template #button-content>
                  <i class="mdi mdi-dots-horizontal"></i>
                  </template>
                  <b-dropdown-item @click="update(row)">Güncelle</b-dropdown-item>
              </b-dropdown>
          </template>
        </Datatable>
      </div>
    </div>
  </Layout>
</template>
